export default __webpack_public_path__ + "3ddfcaba4bddfb0319007bd8a7772e1b.jpg";